
import { useEffect, useState } from "react";
import axios from "axios";

const useProvinciaData = (year, mes, token, idAdministrador) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `https://seguimientoconductor-nodejs-pits.com/administrador_seginus/nfu-solicitudes-por-provincia`,
          { anio: year, mes: mes, id_administrador: idAdministrador },
          { headers: { Authorization: token } }
        );
        setData(response.data);
      } catch (error) {
         
      }
    };
    
    if (token && idAdministrador) {
      fetchData();
    } else {
      setLoading(false);
    }
  }, [year, mes, token, idAdministrador]);

  return {data, loading};
};

export default useProvinciaData;